import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  columnVisible: {
    key: true,
    title: true,
    status: true,
    comments: true,
    last_executed_date: true,
    last_executed_by: true,
    type: false, 
    priority: false,
    labels: false,
    generated_by_user: false,
    updated_by_user: false,
    estimated_duration: false,
    created_at: false,  
    updated_at: false,
    actions: true,
  },
};

const testRunDetailsSlice = createSlice({
  name: 'testrundetails',
  initialState,
  reducers: {
    setVisibleColumn: (state, action) => {
      state.columnVisible = action.payload;
    },
  },
});

export const {
  setVisibleColumn
} = testRunDetailsSlice.actions;

export default testRunDetailsSlice.reducer;
